import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b9a0a9a4-84ed-4294-94dd-1d95262f375b/artifacts/w42uu3e3_Gemini_Generated_Image_md5ockmd5ockmd5o.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Workshops", path: "/workshops" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleEnquire = () => {
    navigate("/contact");
    setIsMenuOpen(false);
  };

  return (
    <header 
      className="sticky top-0 z-50 bg-white/98 backdrop-blur-md border-b border-[#E2E8F0] shadow-sm"
      data-testid="header"
    >
      <div className="container-main">
        <div className="flex items-center justify-between h-[72px] md:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center focus-ring rounded-lg"
            data-testid="header-logo-link"
            aria-label="Be AI Ready - Home"
          >
            <img
              src={LOGO_URL}
              alt="Be AI Ready - Practical AI Training & Workshops in Australia"
              className="h-10 md:h-12 w-auto"
              data-testid="header-logo"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link rounded-md ${
                  location.pathname === link.path ? "active text-[#008A90] bg-[#F0FDFA]" : ""
                }`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button
              onClick={handleEnquire}
              className="bg-[#0A192F] hover:bg-[#112240] text-white font-semibold px-5 py-2.5 text-[14px] shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
              data-testid="header-enquire-btn"
            >
              Enquire About a Workshop
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#0A192F] rounded-lg hover:bg-[#F8FAFC] transition-colors focus-ring"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div 
            className="md:hidden py-4 border-t border-[#E2E8F0] animate-fade-in"
            data-testid="mobile-nav"
          >
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg font-medium text-[15px] transition-colors ${
                    location.pathname === link.path
                      ? "bg-[#F0FDFA] text-[#008A90]"
                      : "text-[#475569] hover:bg-[#F8FAFC]"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 px-4">
                <Button
                  onClick={handleEnquire}
                  className="w-full bg-[#0A192F] hover:bg-[#112240] text-white font-semibold py-3"
                  data-testid="mobile-enquire-btn"
                >
                  Enquire About a Workshop
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
